import { Storage } from '../util/storage';
declare var jDrupal;
declare var Promise;
declare var fetch;
declare var _;

export class Firebase {

    constructor() {

    }

    public init(options: any) {

    }


}
